module.exports = __webpack_public_path__ + "media/images/back_slide_2-86524ac5e249ae8e6bd98fdb64b2c51a.jpg";